export default "assets/images/line-bottom-manifest-e7f2f310.svg";